import React from 'react';
import { StashLogo } from '@stashinvest/react-assets';

type NoAuthNavBarProps = {
	children?: React.ReactNode;
};

export const NoAuthNavBar = ({ children }: NoAuthNavBarProps) => (
	<header className="flex items-center justify-between bg-background px-[1em] shadow-[0_2px_4px_0_rgba(0,0,0,0.2)] py-[0.813em]">
		<StashLogo className="relative z-[1] mr-contentLarge flex h-[1.3rem] !pl-0" />
		{children}
	</header>
);
